/*! Bootstrap 5 integration for DataTables' FixedColumns
 * © SpryMedia Ltd - datatables.net/license
 */

import jQuery from 'jquery';
import DataTable from 'datatables.net-bs5';
import FixedColumns from 'datatables.net-fixedcolumns';

// Allow reassignment of the $ variable
let $ = jQuery;



export default DataTable;
